var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmitted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 1.25H4.9375C4.07417 1.25 3.375 1.95 3.375 2.8125V17.1875C3.375 18.05 4.075 18.75 4.9375 18.75H15.5625C16.425 18.75 17.125 18.05 17.125 17.1875V10.625C17.125 9.7962 16.7958 9.00134 16.2097 8.41529C15.6237 7.82924 14.8288 7.5 14 7.5H12.4375C12.0231 7.5 11.6257 7.33538 11.3326 7.04235C11.0396 6.74933 10.875 6.3519 10.875 5.9375V4.375C10.875 3.5462 10.5458 2.75134 9.95971 2.16529C9.37366 1.57924 8.5788 1.25 7.75 1.25ZM13.2583 10.3633C13.3083 10.2967 13.3445 10.2208 13.3647 10.14C13.385 10.0592 13.3888 9.97512 13.3761 9.89279C13.3634 9.81047 13.3344 9.73152 13.2907 9.66058C13.247 9.58964 13.1896 9.52815 13.1219 9.47971C13.0541 9.43127 12.9773 9.39687 12.8961 9.37852C12.8148 9.36018 12.7307 9.35826 12.6487 9.37288C12.5667 9.38751 12.4885 9.41838 12.4186 9.46368C12.3487 9.50898 12.2885 9.56779 12.2417 9.63667L9.545 13.4117L8.19167 12.0583C8.07319 11.9479 7.91648 11.8878 7.75456 11.8907C7.59265 11.8935 7.43816 11.9591 7.32365 12.0736C7.20914 12.1882 7.14354 12.3426 7.14069 12.5046C7.13783 12.6665 7.19793 12.8232 7.30833 12.9417L9.18333 14.8167C9.24749 14.8808 9.32483 14.9302 9.40999 14.9614C9.49515 14.9926 9.58608 15.0049 9.67647 14.9974C9.76686 14.99 9.85455 14.963 9.93344 14.9182C10.0123 14.8735 10.0805 14.8121 10.1333 14.7383L13.2583 10.3633Z",
    fill: "#328C2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0592 1.51333C11.7479 2.30747 12.1265 3.32379 12.125 4.375V5.9375C12.125 6.11 12.265 6.25 12.4375 6.25H14C15.0512 6.24854 16.0675 6.62707 16.8617 7.31583C16.495 5.92142 15.7646 4.64942 14.7451 3.62991C13.7256 2.6104 12.4536 1.87997 11.0592 1.51333Z",
    fill: "#328C2A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitted);
export default __webpack_public_path__ + "static/media/submitted.034b17350dfd07a9c76c194ccfc96023.svg";
export { ForwardRef as ReactComponent };